// test821
(821 && 0);
